export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',

  // 建银智能评估系统菜单
  'menu.operations': '运营概况',
  'menu.customer': '客户管理',
  'menu.task': '任务管理',
  'menu.report': '报告管理',
  'menu.activity': '活动管理',
  'menu.finance': '财务管理',
  'menu.platform': '平台维护',
  'menu.netValueSolution': '净值方案',
  'menu.reportTemplate': '报告模板配置',
  'menu.ledger': '台账管理',
  'menu.inquiryBatch': '批量询价',
  'menu.system': '系统管理',

  // 系统管理子菜单
  'menu.organization': '机构管理',
  'menu.dept': '部门管理',
  'menu.district': '行政区划管理',
  'menu.logs': '操作日志',
  'menu.user': '用户管理',
  'menu.personal': '个人设置',
  'menu.role': '角色管理',
  'menu.settings': '系统设置',

  // 完整的系统管理子菜单路径
  'menu.system.organization': '机构管理',
  'menu.system.organizationAdd': '新增机构',
  'menu.system.organizationEdit': '编辑机构',
  'menu.system.organizationView': '机构详情',
  'menu.system.dept': '部门管理',
  'menu.system.district': '行政区划管理',
  'menu.system.businessSubType': '业务子类型',
  'menu.system.formProfile': '表单配置包',
  'menu.system.formProfileDetail': '配置包详情',
  'menu.system.certRecognizeEval': '权属识别评测',
  'menu.system.logs': '操作日志',
  'menu.system.user': '用户管理',
  'menu.system.userCreate': '新增用户',
  'menu.system.userEdit': '编辑用户',
  'menu.system.personal': '个人设置',
  'menu.system.role': '角色管理',
  'menu.system.roleCreate': '新增角色',
  'menu.system.permission': '权限管理',
  'menu.system.menu': '菜单配置',
  'menu.system.settings': '系统设置',

  // 完整的客户管理子菜单路径
  'menu.customer.customerAdd': '新增客户',
  'menu.customer.customerEdit': '编辑客户',
  'menu.customer.customerView': '客户详情',
  'menu.customer.customerUserCreate': '新增客户用户',
  'menu.customer.customerUserEdit': '编辑客户用户',

  // 完整的任务管理子菜单路径
  'menu.task.taskMyTask': '我的任务',
  'menu.task.taskStatistics': '任务统计',
  'menu.task.taskSupplement': '任务接单',
  'menu.task.taskSupplementEdit': '编辑任务接单',
  'menu.task.taskCreate': '创建任务',
  'menu.task.taskMultiProperty': '多套任务',
  'menu.task.reportReview': '我的审核',
  'menu.task.reportDetail': '报告详情',
  'menu.task.taskMultiPropertyReview': '多套审核',

  // 完整的报告管理子菜单路径
  'menu.report.reportStatistics': '报告统计',
  'menu.report.reportDetail': '报告详情',

  // 完整的净值方案子菜单路径
  'menu.netValueSolution.netValueSolutionAdd': '新增净值方案',
  'menu.netValueSolution.netValueSolutionList': '净值方案列表',
  'menu.netValueSolution.netValueSolutionCommonParams': '通用参数管理',
  'menu.netValueSolution.netValueSolutionPlanCustomParams': '自定义参数',
  'menu.netValueSolutionAdd': '新增净值方案',
  'menu.netValueSolutionList': '净值方案列表',
  'menu.netValueSolutionCommonParams': '通用参数管理',
  'menu.netValueSolutionPlanCustomParams': '自定义参数',

  // 完整的报告模板配置子菜单路径
  'menu.reportTemplate.reportTemplateList': '模板配置列表',
  'menu.reportTemplate.reportTemplateCommonParams': '通用参数与子项',
  'menu.reportTemplate.reportTemplateDetail': '模板版本配置',
  'menu.reportTemplate.reportTemplateAdd': '新增报告配置',
  'menu.reportTemplateList': '模板配置列表',
  'menu.reportTemplateCommonParams': '通用参数与子项',
  'menu.reportTemplateDetail': '模板版本配置',
  'menu.reportTemplateAdd': '新增报告配置',

  // 完整的台账管理子菜单路径
  'menu.ledger.ledgerList': '台账明细',
  'menu.ledgerList': '台账明细',
  'menu.ledger.ledgerInquiry': '询价台账',
  'menu.ledgerInquiry': '询价台账',
  'menu.ledger.ledgerInquiryDetail': '询价台账详情',
  'menu.ledgerInquiryDetail': '询价台账详情',
  'menu.ledger.ledgerEdit': '编辑台账',
  'menu.ledgerEdit': '编辑台账',
};
